import { render, staticRenderFns } from "./favourite-products-section.vue?vue&type=template&id=90e274dc&"
import script from "./favourite-products-section.vue?vue&type=script&lang=js&"
export * from "./favourite-products-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports